import React from 'react'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    link: string
}

const embedLink = '/embed'

const processEmbedLink = (link: string) => {
    if (link.indexOf(embedLink) === -1) {
        return `${link}`
    }
    return link
}

export const isCityPulse = (link: string) => {
    return link.indexOf('download.pwc') >= 0
}

export const CityPulse: React.FC<Props> = (props: Props) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    return (
        <iframe
            width={'100%'}
            height={'700px'}
            frameBorder={0}
            scrolling="no"
            src={processEmbedLink(props.link)}
            sandbox={'allow-same-origin allow-popups allow-scripts'}
        />
    )
}
